"use client";

import EventClient from "@2u-landing-pages/utils/event-client";
import { renderMark, renderText } from "@2u-landing-pages/utils/contentful-richtext";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import { Body } from "@red-digital/bricks";
import cn from "classnames";
import React from "react";
import { LeadFormIntegratedProps } from "../LeadFormIntegrated.types";

interface LeadFormFootnoteProps {
  footnote: NonNullable<LeadFormIntegratedProps["footnote"]>;
  parseMetadata?: LeadFormIntegratedProps["parseMetadata"];
  phoneNumber?: LeadFormIntegratedProps["phoneNumber"];
  isLastStep: boolean;
  styles: Record<string, string>;
}

export const LeadFormFootnote: React.FC<LeadFormFootnoteProps> = ({
  footnote,
  parseMetadata,
  phoneNumber,
  isLastStep,
  styles,
}) => {
  const handleExternalLinkClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    EventClient.elementClicked({
      webElement: {
        elementType: "Landing Page",
        htmlId: event.currentTarget.href,
        location: "LoadForm",
        name: event.currentTarget.innerText,
        position: "",
        text: "",
      },
    });
  };

  return documentToReactComponents(footnote, {
    renderMark,
    renderText: (text) => renderText(parseMetadata?.(text) || text, phoneNumber),
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node: any, children: React.ReactNode) => (
        <Body
          className={cn(styles.footnote, {
            [styles.footnoteHidden]: isLastStep,
          })}
          variant="caption-md"
        >
          {children}
        </Body>
      ),
      [INLINES.HYPERLINK]: (node: any) => {
        const { uri } = node?.data;
        const content = node?.content?.[0];
        if (content && "value" in content) {
          return (
            <a href={uri} target="_blank" rel="noopener noreferrer" onClick={handleExternalLinkClick}>
              {content.value}
            </a>
          );
        }
        return null;
      },
    },
  });
};
